import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgFullPackage = (props) => (
  <SvgIcon {...props} title="Full package" viewBox="1 1 21 21">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      zoomAndPan="magnify"
      viewBox="0 0 135 135.000003"
      height="24"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      {...props}
    >
      <defs>
        <clipPath id="378f250d67">
          <path
            d="M 0.496094 0 L 134.503906 0 L 134.503906 134.007812 L 0.496094 134.007812 Z M 0.496094 0 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="315b6cfe6b">
          <path
            d="M 9.871094 89 L 22 89 L 22 124.769531 L 9.871094 124.769531 Z M 9.871094 89 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="0ec6187715">
          <path
            d="M 113 9.375 L 125.269531 9.375 L 125.269531 45 L 113 45 Z M 113 9.375 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#378f250d67)"></g>
      <path
        fill="#017163"
        d="M 47.660156 55.554688 L 47.660156 78.441406 L 87.328125 78.441406 L 87.328125 55.554688 L 76.820312 55.554688 L 76.820312 69.3125 C 76.820312 69.683594 76.726562 70.027344 76.546875 70.351562 C 76.367188 70.675781 76.117188 70.933594 75.800781 71.128906 C 75.484375 71.324219 75.140625 71.429688 74.769531 71.445312 C 74.398438 71.457031 74.046875 71.382812 73.71875 71.210938 L 67.496094 68.046875 L 61.269531 71.210938 C 60.941406 71.382812 60.589844 71.460938 60.21875 71.445312 C 59.847656 71.429688 59.503906 71.324219 59.1875 71.128906 C 58.871094 70.933594 58.625 70.675781 58.441406 70.351562 C 58.261719 70.027344 58.171875 69.683594 58.171875 69.3125 L 58.171875 55.554688 Z M 47.660156 55.554688 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 68.460938 63.753906 L 72.550781 65.832031 L 72.550781 55.554688 L 62.4375 55.554688 L 62.4375 65.832031 L 66.527344 63.753906 C 67.171875 63.425781 67.816406 63.425781 68.460938 63.753906 Z M 68.460938 63.753906 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g clipPath="url(#315b6cfe6b)">
        <path
          fill="#017163"
          d="M 21.523438 122.109375 L 21.523438 89.082031 L 9.871094 89.082031 L 9.871094 124.621094 L 21.523438 124.621094 Z M 21.523438 122.109375 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#017163"
        d="M 25.792969 119.976562 L 35.078125 119.976562 L 35.078125 93.726562 L 25.792969 93.726562 Z M 25.792969 119.976562 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 98.816406 97.734375 C 98.757812 97.027344 98.554688 96.363281 98.203125 95.746094 C 97.851562 95.128906 97.382812 94.617188 96.800781 94.207031 C 96.304688 93.886719 95.773438 93.660156 95.195312 93.527344 C 94.621094 93.394531 94.042969 93.367188 93.457031 93.4375 C 92.871094 93.511719 92.316406 93.683594 91.789062 93.949219 C 91.265625 94.21875 90.800781 94.570312 90.398438 95 L 80.355469 105.042969 C 79.9375 105.457031 79.433594 105.667969 78.84375 105.667969 L 56.453125 105.667969 C 56.167969 105.667969 55.898438 105.613281 55.636719 105.503906 C 55.375 105.394531 55.144531 105.242188 54.945312 105.042969 C 54.742188 104.84375 54.589844 104.609375 54.480469 104.351562 C 54.371094 104.089844 54.320312 103.816406 54.320312 103.53125 C 54.320312 103.25 54.371094 102.976562 54.480469 102.714844 C 54.589844 102.453125 54.742188 102.222656 54.945312 102.023438 C 55.144531 101.824219 55.375 101.667969 55.636719 101.5625 C 55.898438 101.453125 56.167969 101.398438 56.453125 101.398438 L 67.378906 101.398438 C 67.253906 100.800781 67.085938 100.21875 66.863281 99.648438 C 66.644531 99.078125 66.378906 98.53125 66.066406 98.007812 C 65.753906 97.484375 65.398438 96.988281 65.003906 96.523438 C 64.605469 96.058594 64.171875 95.632812 63.703125 95.242188 C 63.238281 94.851562 62.738281 94.5 62.210938 94.195312 C 61.683594 93.886719 61.132812 93.628906 60.5625 93.414062 C 59.988281 93.199219 59.40625 93.035156 58.804688 92.921875 C 58.207031 92.804688 57.601562 92.742188 56.992188 92.730469 L 39.347656 96.316406 L 39.347656 117.289062 L 63.742188 120.996094 L 77.960938 120.972656 L 97.429688 101.507812 C 97.929688 101.011719 98.296875 100.433594 98.539062 99.773438 C 98.78125 99.113281 98.875 98.433594 98.816406 97.734375 Z M 98.816406 97.734375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g clipPath="url(#0ec6187715)">
        <path
          fill="#017163"
          d="M 113.464844 11.886719 L 113.464844 44.914062 L 125.117188 44.914062 L 125.117188 9.375 L 113.464844 9.375 Z M 113.464844 11.886719 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#017163"
        d="M 99.914062 14.875 L 99.914062 40.269531 L 109.195312 40.269531 L 109.195312 14.019531 L 99.914062 14.019531 Z M 99.914062 14.875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 95.644531 16.707031 L 71.246094 13 L 57.027344 13.023438 L 37.558594 32.488281 C 37.3125 32.734375 37.09375 33.007812 36.90625 33.300781 C 36.71875 33.59375 36.566406 33.90625 36.449219 34.234375 C 36.328125 34.5625 36.246094 34.898438 36.199219 35.246094 C 36.152344 35.589844 36.144531 35.9375 36.175781 36.285156 C 36.207031 36.632812 36.273438 36.972656 36.378906 37.304688 C 36.480469 37.636719 36.621094 37.957031 36.792969 38.257812 C 36.96875 38.5625 37.171875 38.839844 37.40625 39.097656 C 37.640625 39.355469 37.902344 39.585938 38.1875 39.789062 C 38.683594 40.105469 39.21875 40.332031 39.792969 40.464844 C 40.367188 40.59375 40.949219 40.625 41.53125 40.554688 C 42.117188 40.480469 42.671875 40.308594 43.199219 40.042969 C 43.722656 39.777344 44.1875 39.425781 44.589844 38.996094 L 54.636719 28.953125 C 55.050781 28.539062 55.554688 28.328125 56.144531 28.328125 L 78.535156 28.328125 C 78.820312 28.328125 79.089844 28.382812 79.351562 28.492188 C 79.613281 28.601562 79.84375 28.753906 80.046875 28.953125 C 80.246094 29.15625 80.398438 29.386719 80.507812 29.648438 C 80.617188 29.910156 80.671875 30.179688 80.671875 30.464844 C 80.671875 30.746094 80.617188 31.019531 80.507812 31.28125 C 80.398438 31.542969 80.246094 31.773438 80.046875 31.972656 C 79.84375 32.171875 79.613281 32.328125 79.351562 32.433594 C 79.089844 32.542969 78.820312 32.597656 78.535156 32.597656 L 67.613281 32.597656 C 67.734375 33.195312 67.902344 33.78125 68.125 34.347656 C 68.34375 34.917969 68.609375 35.464844 68.921875 35.988281 C 69.234375 36.511719 69.589844 37.007812 69.988281 37.472656 C 70.382812 37.9375 70.816406 38.363281 71.285156 38.753906 C 71.753906 39.144531 72.25 39.496094 72.777344 39.800781 C 73.304688 40.109375 73.855469 40.371094 74.425781 40.582031 C 75 40.796875 75.585938 40.960938 76.183594 41.078125 C 76.785156 41.191406 77.386719 41.253906 78 41.269531 L 95.644531 37.679688 Z M 95.644531 16.707031 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  </SvgIcon>
);

export default SvgFullPackage;
